import { Modal, inputCls, btnTurq } from "../bits";
import { Plus, Trash2 } from "lucide-react";

export function StaffHistoryModal({ open, member, onClose, opps, logForm, setLogForm, history, busy, onLog, onRemovePart }) {
  return (
    <Modal open={open} onClose={onClose}
      title={`سجل مشاركات ${member?.name || ""}`} wide testid="staff-history-modal">
      <div className="space-y-4">
        <div className="flex gap-2 flex-wrap items-end bg-bg rounded-xl p-3">
          <div className="flex-1 min-w-[180px]">
            <label className="text-[11px] font-bold text-mutext block mb-1">الفرصة التطوعية</label>
            <select data-testid="staff-opp-select" value={logForm.opportunity_id}
              onChange={(e) => setLogForm({ ...logForm, opportunity_id: e.target.value })} className={inputCls}>
              <option value="">— اختر الفرصة —</option>
              {opps.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          </div>
          <div className="w-24">
            <label className="text-[11px] font-bold text-mutext block mb-1">الساعات</label>
            <input data-testid="staff-hours-input" type="number" min="1" value={logForm.hours}
              onChange={(e) => setLogForm({ ...logForm, hours: Number(e.target.value) })} className={inputCls} />
          </div>
          <div className="w-36">
            <label className="text-[11px] font-bold text-mutext block mb-1">التاريخ</label>
            <input data-testid="staff-date-input" type="date" value={logForm.date}
              onChange={(e) => setLogForm({ ...logForm, date: e.target.value })} className={inputCls} dir="ltr" />
          </div>
          <button data-testid="staff-log-submit-btn" onClick={onLog} disabled={busy} className={btnTurq}>
            <Plus className="w-4 h-4" /> تسجيل
          </button>
        </div>
        <div className="max-h-60 overflow-auto rounded-xl border border-brd">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-turq-900 text-white">
                <th className="text-right px-3 py-2">الفرصة</th>
                <th className="text-right px-3 py-2">الساعات</th>
                <th className="text-right px-3 py-2">التاريخ</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody>
              {history.map((p) => (
                <tr key={p.id} data-testid={`staff-part-${p.id.slice(0, 8)}`} className="border-t border-brd/50">
                  <td className="px-3 py-2 font-bold">{p.opportunity_name}</td>
                  <td className="px-3 py-2">{p.hours}</td>
                  <td className="px-3 py-2" dir="ltr">{p.date}</td>
                  <td className="px-3 py-2 text-left">
                    <button data-testid={`staff-part-delete-${p.id.slice(0, 8)}`} onClick={() => onRemovePart(p.id)}
                      className="text-coral-900 dark:text-coral-300 hover:scale-110 transition-transform">
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </td>
                </tr>
              ))}
              {history.length === 0 && <tr><td colSpan={4} className="px-3 py-6 text-center text-mutext">لا توجد مشاركات مسجلة بعد</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
}
